module.exports = __webpack_public_path__ + "assets/normal/images/Empty_4.569c752f.png";